<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    id="information__icon"
  >
    <path
      d="M18 0H2C1.47 0 0.96 0.21 0.59 0.59C0.21 0.96 0 1.47 0 2V14C0 14.53 0.21 15.04 0.59 15.41C0.96 15.79 1.47 16 2 16H6L10 20L14 16H18C18.53 16 19.04 15.79 19.41 15.41C19.78 15.03 20 14.53 20 14V2C20 1.47 19.79 0.96 19.41 0.59C19.04 0.21 18.53 0 18 0ZM2 14V2H18V14H13.17L10 17.17L6.83 14M8.05 4.04C8.59 3.68 9.3 3.5 10.19 3.5C11.13 3.5 11.88 3.71 12.42 4.12C12.96 4.54 13.23 5.1 13.23 5.8C13.23 6.24 13.08 6.63 12.79 7C12.5 7.36 12.12 7.64 11.66 7.85C11.4 8 11.23 8.15 11.14 8.32C11.05 8.5 11 8.72 11 9H9C9 8.5 9.1 8.16 9.29 7.92C9.5 7.68 9.84 7.4 10.36 7.08C10.62 6.94 10.83 6.76 11 6.54C11.14 6.33 11.22 6.08 11.22 5.8C11.22 5.5 11.13 5.28 10.95 5.11C10.77 4.93 10.5 4.85 10.19 4.85C9.92 4.85 9.7 4.92 9.5 5.06C9.34 5.2 9.24 5.41 9.24 5.69H7.27C7.22 5 7.5 4.4 8.05 4.04ZM9 12V10H11V12H9Z"
      fill="var(--textinactive)"
      :stroke="isColorHover"
    />
  </svg>
</template>

<script>
export default {
  name: "InformationIcon",
  props: {
    colorHover: {
      required: false,
      type: String,
      default: ""
    }
  },
  computed: {
    isColorHover() {
      return this.colorHover === "var(--textinactive)" ? "" : this.colorHover;
    }
  }
};
</script>
